export var longFormData = {
  //https://uk.hotels.com/go/thailand/wat-arun?format=json
  "/go/thailand/wat-arun": {
    "data": {
      "page": {
        "html": {
          "lang": "en-GB",
          "langdir": "LTR",
          "locale": "en_GB",
          "attributes": {
            "xmlns:fb": "http://www.facebook.com/2008/fbml"
          }
        },
        "head": {
          "title": "Wat Arun in Bangkok - Temple of Dawn - Go Guides",
          "links": [{
            "href": "https://uk.hotels.com/go/thailand/wat-arun",
            "rel": "canonical"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "x-default",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-US",
            "rel": "alternate"
          }, {
            "href": "https://ca.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-CA",
            "rel": "alternate"
          }, {
            "href": "https://uk.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-GB",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-LA",
            "rel": "alternate"
          }, {
            "href": "https://au.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-AU",
            "rel": "alternate"
          }, {
            "href": "https://sg.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-SG",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-TH",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-AS",
            "rel": "alternate"
          }, {
            "href": "https://nz.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-NZ",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-MY",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-MX",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-CN",
            "rel": "alternate"
          }, {
            "href": "https://in.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-IN",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-ZA",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-KR",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-JP",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-IL",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-HK",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-TW",
            "rel": "alternate"
          }, {
            "href": "https://ie.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-IE",
            "rel": "alternate"
          }, {
            "href": "https://ph.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-PH",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-VN",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go/thailand/wat-arun",
            "hreflang": "en-ID",
            "rel": "alternate"
          }],
          "metas": [{
            "name": "title",
            "content": "Wat Arun in Bangkok - Temple of Dawn - Go Guides"
          }, {
            "name": "keywords",
            "content": ""
          }, {
            "name": "description",
            "content": "Wat Arun, locally known as Wat Chaeng, is a landmark temple on the west (Thonburi) bank of the Chao Phraya river. It’s easily one of the most stunning temples in Bangkok, not only because of its riverside location but also because the design is very different from the other temples you can visit in the Thai"
          }, {
            "name": "theme-color",
            "content": "#ffffff"
          }, {
            "content": "105208249622845",
            "property": "fb:app_id"
          }, {
            "content": "website",
            "property": "og:type"
          }, {
            "content": "Wat Arun in Bangkok - Temple of Dawn - Go Guides",
            "property": "og:title"
          }, {
            "content": "Wat Arun, locally known as Wat Chaeng, is a landmark temple on the west (Thonburi) bank of the Chao Phraya river. It’s easily one of the most stunning temples in Bangkok, not only because of its riverside location but also because the design is very different from the other temples you can visit in the Thai",
            "property": "og:description"
          }, {
            "content": "https://a.cdn-hotels.com/gdcs/production189/d768/a05e9e67-8808-47c0-84ab-3a0b086d48b8.jpg",
            "property": "og:image"
          }]
        }
      },
      "suggestedLanguages": [],
      "common": {
        "clientToken": "Lzmuo0XzDqJRsxqNEodC-hki4-w.",
        "injected_data": {
          "commonDataBlock": {
            "user": {
              "dossierId": "80454537",
              "loyaltyAccountId": "43777247",
              "sessionId": "m2WB8Vzftc0h0WhXracQ2FJuZQ.caa-77d4f449bf-lzrqh",
              "guid": "60983dcf-9fe8-4006-b289-0431ce01eb92",
              "wrStatus": "WR Member",
              "pos": "HCOM_UK",
              "locale": "en_GB",
              "geolocation": {
                "latitude": "1.29",
                "longitude": "103.86"
              },
              "platformId": "Desktop",
              "clientId": "251426",
              "signInState": "auth",
              "ipAddress": "27.111.209.200",
              "hrwMemberStatus": "member",
              "fcStatus": "connected",
              "newsletterOptInStatus": "notSubscribed",
              "visitorState": "newVisitor",
              "md5email": "3e77e262807b42c5a0f649f18314b25b",
              "existingCustomer": 0,
              "hrwTier": "gold",
              "segments": {},
              "signInMethod": "HoB",
              "loyalty": {
                "nightsToFreeNight": 10,
                "freeNightsAvailable": 1,
                "accountNightsBalance": 10,
                "totalNightsLifetimeEarned": 60,
                "totalNightsLifetimeRedeemed": 50,
                "freeNightUSD": 129.18,
                "freeNightLockedCurrency": 4404.08,
                "currency": "THB"
              },
              "cookieConsentStatus": "User Consented",
              "sha256Email": "60b5313ad0ac64f58ab1ea3565a287eb89b38af248ab6d7db59efd8029709ff1",
              "customerId": "1a75d41b-a2e1-44dc-911b-166a903e300d"
            },
            "page": {
              "pageName": "go guides :: long form :: things to do :: thailand|wat-arun",
              "siteSection": "go guides :: long form",
              "random10Alpha": "dty1v84ni0",
              "random10Numeric": "7795728899",
              "currency": "THB",
              "additionalPageInformation2": "go guides :: long form :: things to do :: thailand|wat-arun",
              "fullURL": "https://uk.hotels.com/go/thailand/wat-arun?format=json",
              "requestId": "1f8121f7-3ca9-11ee-ab46-526452bb9da8",
              "dataCentre": "chx"
            },
            "search": {
              "destinationId": "1714339"
            },
            "booking": {
              "bookingError": {},
              "lpas": false
            },
            "marketing": {
              "lastTouchedMarketingCode": "seo.hcom.gb.z.www.google.com",
              "restrictedLastTouch": {
                "marketingCode": "seo.hcom.gb.z.www.google.com",
                "fullMarketingCode": "seo.hcom.gb.z.www.google.com.kwrd=unknown"
              },
              "currentUnrestricted": {
                "marketingCode": "seo.hcom.gb.z.www.google.com",
                "fullMarketingCode": "seo.hcom.gb.z.www.google.com.kwrd=unknown"
              },
              "currentRestricted": {
                "marketingCode": "Brand",
                "fullMarketingCode": "Brand"
              },
              "fullMarketingTrackingCode": "seo.hcom.gb.z.www.google.com.kwrd=unknown",
              "kwrd": "seo unknown term",
              "h4p": {}
            },
            "property": {},
            "event": {
              "bot": false
            },
            "mvtHistory": {
              "mvts": "128.0.0:138.0.2:236.0.0:265.1.0.i6:945.0.0:1068.1.0.i2:1825.0.0:1871.2.0.i7:1917.0.0:1946.0.0:2089.2.0.i3:2383.2.0.i1:2569.0.0:2594.0.0:2596.0.0:2634.1.0.i10:2760.1.0:2796.0.0.i2:2872.0.0:2927.0.0:2929.0.0.i3:3106.0.0:3277.1.0.i5:3427.0.0:3465.0.0:3891.0.0:3988.1.0.i2:4115.0.0:4154.2.0.i4:4163.0.0:4170.1.0.i3:4247.0.0:4514.1.0.i1:4532.1.0.i4:4583.0.0:4596.0.0:4612.1.0.i1:4983.0.0:365.2.0.i117:376.0.0.i0:555.10.0.i1:785.1.0.i12:904.0.0.i0:972.0.0.i0:1167.0.0.i0:1291.20.0.i21:1292.6.0.i9:1293.0.0.i37:1294.24.0.i36:1366.0.0.i0:1439.1.0.i7:2176.1.0.i45:2638.0.0.i0:2768.0.0.i0:2791.0.0.i2:3249.0.0.i0:3664.0.0.i0:3736.0.0.i0:3822.0.0.i0:4178.0.0.i0:4200.0.0.i0:4290.0.0.i0:4440.2.0.i5:4592.0.0.i0:4678.0.0.i1:4725.0.0.i1:4793.1.0.i1:4794.0.0.i38:4824.1.0.i5:4827.1.0.i1:4828.1.0.i5:4869.0.0.i1:4935.0.0.i1:4937.0.0.i0:4952.1.0.i50:4953.1.0.i47:4956.1.0.i66:4961.0.0.i1:4964.1.0.i2:4992.0.0.i1:5003.1.0.i8:5037.0.0.i0:5073.0.0.i1:5104.0.0.i1:5167.0.0.i1:5184.0.0.i1:5227.1.0.i3:5234.0.0.i1:5236.1.0.i2:5274.0.0.i0:5277.0.0.i1:5302.0.0.i0:5342.0.0.i0:5349.0.0.i1:5358.0.0.i1:5571.1.0.i2:5658.0.0.i0:5663.0.0.i0:5664.0.0.i1:5687.0.0.i1:5695.0.0.i1:5756.0.0.i1:5758.0.0.i1:5759.0.0.i1:5760.0.0.i1:5775.1.0.i3:5826.0.0.i1:5843.0.0.i1:5845.1.0.i2:5940.0.0.i1:5971.0.0.i1:5979.0.0.i0:6033.1.0.i9:6039.0.0.i1:6041.1.0.i2:6046.1.0.i3:6171.2.0.i16:6184.0.0.i0:6205.0.0.i0:6206.0.0.i0:6232.0.0.i0:6242.0.0.i0:6244.0.0.i0:6246.0.0.i0:6271.0.0.i1:6299.0.0.i0:6357.1.0.i0:6369.2.0.i5:6370.1.0.i4:6388.0.0.i0:6425.2.0.i0:6439.0.0.i0:6440.1.0.i1:6442.0.0.i0:6451.0.0.i0:6494.2.0.i0:6532.0.0.i1:6544.0.0.i0:6549.0.0.i0:6550.0.0.i0:6553.1.0.i5:6667.0.0.i0:6690.0.0.i0:6710.0.0.i0:6725.8.0.i2:6726.2.0.i2:6727.0.0.i0:6728.0.0.i0:6751.0.0.i0:6755.1.0.i2:6761.0.0.i0:6775.0.0.i0:6779.0.0.i0:6807.1.0.i1:6859.3.0.i0:6866.0.0.i0:6874.0.0.i0:6907.0.0.i0:6909.0.0.i0:6913.0.0.i0:6927.0.0.i0:6938.1.0.i2:6939.1.0.i2:6940.0.0.i0:6941.0.0.i0:6942.1.0.i2:6944.1.0.i2:6946.0.0.i0:6947.1.0.i2:6959.2.0.i20:6966.1.0.i19:7004.0.0.i0:7015.1.0.i7:7031.0.0.i0:7036.0.0.i0:7064.0.0.i7:7066.0.0.i0:7078.0.0.i0:7079.1.0.i3:7080.0.0.i0:7088.0.0.i0:7108.0.0.i0:7115.0.0.i0:7132.0.0.i0:7144.1.0.i3:7145.1.0.i2:7146.0.0.i0:7148.0.0.i0:7157.0.0.i0:7192.1.0.i7:7197.0.0.i0:7214.0.0.i0:7215.1.0.i9:7238.0.0.i0:7280.1.0.i3:7284.0.0.i0:7296.9.0.i30:7305.0.0.i0:7306.2.0.i2:7308.0.0.i0:7327.0.0.i0:7334.1.0.i1:7343.1.0.i5:7353.0.0.i0:7360.1.0.i1:7362.1.0.i32:7368.1.0.i2:7384.0.0.i0:7385.0.0.i0:7395.3.0.i9:7402.1.0.i7:7404.0.0.i0:7414.1.0.i2:7436.0.0.i0:7440.0.0.i0:7450.0.0.i0:7451.0.0.i0:7484.3.0.i3:7500.0.0.i0:7501.0.0.i0:7527.0.0.i0:7550.0.0.i0:7552.1.0.i23:7561.3.0.i84:7576.0.0.i0:7603.0.0.i0:7605.1.0.i0:7625.0.0.i0:7634.0.0.i0:7635.0.0.i0:7660.1.0.i1:7666.0.0.i0:7696.1.0.i0:7700.0.0.i0:7715.0.0.i0:7740.3.0.i11:7741.0.0.i0:7763.0.0.i0:7765.2.0.i5:7787.0.0.i0:7808.0.0.i0:7821.0.0.i0:7825.0.0.i0:7832.2.0.i3:7844.0.0.i0:7858.0.0.i0:7861.4.0.i26:7865.0.0.i0:7867.0.0.i0:7870.0.0.i0:7871.0.0.i0:7878.0.0.i2:7890.1.0.i1:7895.0.0.i0:7896.1.0.i0:7899.0.0.i0:7912.0.0.i0:7913.0.0.i0:7937.0.0.i0:7947.0.0.i0:7950.0.0.i0:7983.0.0.i0:7990.0.0.i0:7992.2.0.i12:8001.0.0.i0:8017.0.0.i0:8026.0.0.i0:8027.2.0.i3:8033.0.0.i0:8037.0.0.i0:8039.0.0.i0:8049.0.0.i0:8056.0.0.i0:8072.0.0.i0:8073.0.0.i0:8075.1.0.i2:8092.0.0.i0:8103.0.0.i9:8115.0.0.i17:8121.1.0.i2:8130.1.0.i0:8141.1.0.i0:8143.1.0.i2:8167.0.0.i0:8171.1.0.i6:8193.0.0.i0:8197.6.0.i7:8210.1.0.i3:8218.0.0.i0:8220.0.0.i0:8227.0.0.i0:8231.2.0.i4:8235.0.0.i0:8248.3.0.i5:8258.2.0.i11:8267.0.0.i0:8272.0.0.i0:8275.1.0.i3:8280.0.0.i0:8287.1.0.i5:8298.0.0.i3:8306.0.0.i0:8326.1.0.i19:8336.2.0.i10:8347.2.0.i13:8348.1.0.i2:8354.1.0.i4:8365.3.0.i4:8385.0.0.i0:8390.2.0.i8:8400.0.0.i0:8405.1.0.i8:8410.3.0.i0:8425.1.0.i6:8426.1.0.i5:8434.0.0.i0:8444.0.0.i0:8448.0.0.i0:8451.0.0.i0:8459.0.0.i0:8477.0.0.i0:8483.0.0.i0:8485.1.0.i6:8494.0.0.i0:8506.0.0.i0:8524.0.0.i0:8536.0.0.i0:8549.2.0.i5:8558.0.0.i0:8591.1.0.i0:8592.0.0.i0:8598.0.0.i0:8605.0.0.i0:8617.0.0.i0:8621.2.0.i2:8624.1.0.i4:8625.2.0.i3:8627.0.0.i0:8637.0.0.i0:8651.2.0.i2:8652.2.0.i2:8656.1.0.i3:8657.0.0.i0:8667.0.0.i0:8671.2.0.i2:8674.1.0.i2:8676.1.0.i2:8683.2.0.i3:8691.1.0.i1:8692.0.0.i0:8693.0.0.i0:8694.1.0.i12:8697.1.0.i6:8698.0.0.i0:8700.0.0.i5:8708.0.0.i0:8711.0.0.i0:8714.1.0.i8:8718.0.0.i0:8738.1.0.i2:8743.1.0.i3:8763.1.0.i3:8769.0.0.i0:8789.1.0.i15:8798.1.0.i2:8817.1.0.i0:8820.0.0.i0:8832.1.0.i0:8867.1.0.i5:8885.0.0.i0:8894.0.0.i0:8900.1.0.i0:8915.0.0.i0:8919.0.0.i0:8928.3.0.i12:8932.2.0.i0:8940.0.0.i0:8941.0.0.i0:8952.0.0.i0:8954.0.0.i0:8955.0.0.i0:8956.0.0.i0:8963.0.0.i0:8967.0.0.i0:8968.0.0.i0:8976.2.0.i6:8987.0.0.i0:8991.1.0.i4:8992.0.0.i0:8996.1.0.i1:9008.0.0.i0:9014.0.0.i0:9023.0.0.i0:9026.0.0.i0:9032.0.0.i0:9035.1.0.i12:9037.1.0.i3:9043.1.0.i8:9048.0.0.i0:9056.0.0.i0:9062.0.0.i0:9068.0.0.i0:9069.0.0.i0:9100.2.0.i3:9121.0.0.i0:9128.0.0.i0:9130.3.0.i4:9134.0.0.i0:9136.0.0.i0:9141.0.0.i0:9145.0.0.i3:9151.0.0.i0:9154.0.0.i0:9155.0.0.i0:9164.0.0.i0:9165.0.0.i0:9166.3.0.i3:9167.0.0.i0:9168.0.0.i0:9169.0.0.i0:9171.0.0.i0:9173.1.0.i2:9174.1.0.i7:9182.0.0.i0:9183.2.0.i7:9197.0.0.i0:9198.3.0.i0:9199.0.0.i0:9201.0.0.i0:9203.0.0.i0:9208.0.0.i0:9214.1.0.i2:9219.2.0.i0:9220.3.0.i9:9229.0.0.i0:9246.0.0.i0:9254.0.0.i0:9255.0.0.i0:9257.1.0.i32:9281.0.0.i0:9282.0.0.i0:9293.1.0.i2:9295.0.0.i0:9296.1.0.i3:9297.0.0.i0:9301.0.0.i0:9306.0.0.i0:9333.1.0.i8:9343.0.0.i0:9347.0.0.i0:9351.0.0.i0:9353.0.0.i0:9363.0.0.i0:9364.0.0.i0:9368.0.0.i0:9385.0.0.i0:9410.0.0.i0:9418.0.0.i0:9419.0.0.i0:9420.2.0.i3:9424.2.0.i1:9427.1.0.i7:9431.0.0.i7:9434.2.0.i3:9439.0.0.i0:9441.2.0.i2:9444.0.0.i0:9455.1.0.i1:9460.1.0.i3:9461.0.0.i0:9469.1.0.i3:9475.1.0.i1:9477.0.0.i0:9483.0.0.i22:9491.1.0.i3:9493.0.0.i0:9501.0.0.i0:9508.0.0.i0:9510.2.0.i2:9513.0.0.i0:9516.2.0.i20:9524.0.0.i0:9528.2.0.i2:9531.3.0.i3:9538.1.0.i0:9549.0.0.i0:9564.0.0.i0:9565.0.0.i0:9566.2.0.i2:9567.2.0.i2:9581.0.0.i0:9583.0.0.i0:9585.2.0.i13:9586.1.0.i1:9588.0.0.i0:9593.0.0.i0:9596.0.0.i0:9601.0.0.i0:9605.2.0.i5:9606.2.0.i13:9613.2.0.i5:9619.2.0.i2:9625.0.0.i0:9629.0.0.i0:9630.1.0.i3:9635.0.0.i0:9656.0.0.i0:9657.0.0.i0:9659.0.0.i0:9660.0.0.i0:9661.0.0.i0:9665.2.0.i5:9669.1.0.i0:9679.1.0.i3:9691.1.0.i6:9692.1.0.i8:9693.0.0.i0:9697.1.0.i1:9699.1.0.i4:9714.0.0.i0:9727.4.0.i3:9728.0.0.i0:9729.1.0.i1:9733.1.0.i16:9737.0.0.i0:9748.0.0.i0:9749.0.0.i0:9750.0.0.i0:9752.0.0.i0:9754.2.0.i5:9757.2.0.i13:9758.1.0.i4:9763.1.0.i2:9771.1.0.i1:9785.0.0.i0:9789.0.0.i0:9792.0.0.i0:9806.2.0.i5:9808.1.0.i2:9810.0.0.i0:9819.1.0.i1:9837.4.0.i4:9854.0.0.i0:9857.0.0.i0:9863.2.0.i2:9864.0.0.i0:9865.0.0.i7:9871.0.0.i0:9876.0.0.i0:9884.5.0.i15:9890.0.0.i0:9892.0.0.i0:9897.0.0.i0:9914.2.0.i2:9924.2.0.i9:9930.0.0.i0:9945.0.0.i0:9948.0.0.i0:9955.0.0.i0:9961.0.0.i0:9962.0.0.i0:9968.0.0.i0:9971.1.0.i14:9974.0.0.i0:9980.0.0.i0:9991.2.0.i5:9992.0.0.i0:9993.0.0.i0:10001.2.0.i2:10002.0.0.i0:10007.2.0.i4:10008.1.0.i2:10013.0.0.i0:10014.1.0.i9:10015.1.0.i5:10025.0.0.i0:10029.1.0.i3:10032.0.0.i0:10033.0.0.i0:10038.1.0.i1:10039.0.0.i0:10040.1.0.i2:10042.1.0.i2:10044.0.0.i0:10049.0.0.i0:10055.0.0.i0:10057.6.0.i6:10058.2.0.i3:10059.0.0.i0:10060.0.0.i0:10061.0.0.i0:10074.0.0.i0:10076.0.0.i0:10077.1.0.i3:10079.0.0.i0:10083.0.0.i0:10085.1.0.i2:10086.0.0.i0:10094.1.0.i4:10101.1.0.i3:10103.1.0.i6:10108.0.0.i0:10110.1.0.i2:10113.0.0.i0:10118.2.0.i3:10121.1.0.i1:10125.1.0.i3:10127.1.0.i2:10135.1.0.i5:10137.0.0.i0:10139.0.0.i0:10142.1.0.i2:10148.1.0.i2:10155.0.0.i0:10173.1.0.i1:10185.0.0.i0:10187.0.0.i0:10192.1.0.i0:10195.0.0.i4:10199.1.0.i2:10200.1.0.i5:10203.1.0.i14:10211.0.0.i0:10212.1.0.i3:10214.0.0.i0:10218.3.0.i1:10220.2.0.i3:10223.1.0.i4:10230.0.0.i0:10231.0.0.i0:10235.0.0.i0:10243.0.0.i0:10246.0.0.i0:10247.1.0.i2:10248.1.0.i5:10251.0.0.i0:10255.0.0.i0:10257.1.0.i2:10259.0.0.i0:10261.1.0.i3:10262.0.0.i0:10264.0.0.i0:10268.0.0.i0:10275.1.0.i2:10276.1.0.i1:10278.1.0.i6:10282.2.0.i6:10286.1.0.i2:10287.0.0.i0:10291.2.0.i4:10299.0.0.i0:10300.1.0.i3:10301.3.0.i2:10306.3.0.i4:10315.1.0.i2:10320.0.0.i0:10323.0.0.i0:10324.0.0.i0:10325.0.0.i0:10326.0.0.i0:10334.0.0.i0:10335.1.0.i1:10336.0.0.i0:10343.2.0.i0:10344.2.0.i0:10345.1.0.i0:10346.0.0.i0:10355.0.0.i0:10361.2.0.i5:10390.2.0.i3:10396.1.0.i2:10397.1.0.i4:10402.1.0.i1:10416.1.0.i1:10423.0.0.i0:10424.0.0.i2:10440.3.0.i2:10443.2.0.i3:10472.0.0.i0:10473.0.0.i0:10482.2.0.i3:10483.0.0.i0:10500.1.0.i5:10517.0.0.i0:10520.0.0.i0:10555.1.0.i1:10565.1.0.i5:10566.3.0.i4:10567.1.0.i2:10569.2.0.i5:10571.5.0.i6|HCOM_UK",
              "athenaMvts": "365.117.2,376.0.0,555.1.10,785.12.1,904.0.0,972.0.0,1167.0.0,1291.21.20,1292.9.6,1293.37.0,1294.36.24,1366.0.0,1439.7.1,2176.45.1,2638.0.0,2768.0.0,2791.2.0,3249.0.0,3664.0.0,3736.0.0,3822.0.0,4178.0.0,4200.0.0,4290.0.0,4440.5.2,4592.0.0,4678.1.0,4725.1.0,4793.1.1,4794.38.0,4824.5.1,4827.1.1,4828.5.1,4869.1.0,4935.1.0,4937.0.0,4952.50.1,4953.47.1,4956.66.1,4961.1.0,4964.2.1,4992.1.0,5003.8.1,5037.0.0,5073.1.0,5104.1.0,5167.1.0,5184.1.0,5227.3.1,5234.1.0,5236.2.1,5274.0.0,5277.1.0,5302.0.0,5342.0.0,5349.1.0,5358.1.0,5571.2.1,5658.0.0,5663.0.0,5664.1.0,5687.1.0,5695.1.0,5756.1.0,5758.1.0,5759.1.0,5760.1.0,5775.3.1,5826.1.0,5843.1.0,5845.2.1,5940.1.0,5971.1.0,5979.0.0,6033.9.1,6039.1.0,6041.2.1,6046.3.1,6171.16.2,6184.0.0,6205.0.0,6206.0.0,6232.0.0,6242.0.0,6244.0.0,6246.0.0,6271.1.0,6299.0.0,6357.0.1,6369.5.2,6370.4.1,6388.0.0,6425.0.2,6439.0.0,6440.1.1,6442.0.0,6451.0.0,6494.0.2,6532.1.0,6544.0.0,6549.0.0,6550.0.0,6553.5.1,6667.0.0,6690.0.0,6710.0.0,6725.2.8,6726.2.2,6727.0.0,6728.0.0,6751.0.0,6755.2.1,6761.0.0,6775.0.0,6779.0.0,6807.1.1,6859.0.3,6866.0.0,6874.0.0,6907.0.0,6909.0.0,6913.0.0,6927.0.0,6938.2.1,6939.2.1,6940.0.0,6941.0.0,6942.2.1,6944.2.1,6946.0.0,6947.2.1,6959.20.2,6966.19.1,7004.0.0,7015.7.1,7031.0.0,7036.0.0,7064.7.0,7066.0.0,7078.0.0,7079.3.1,7080.0.0,7088.0.0,7108.0.0,7115.0.0,7132.0.0,7144.3.1,7145.2.1,7146.0.0,7148.0.0,7157.0.0,7192.7.1,7197.0.0,7214.0.0,7215.9.1,7238.0.0,7280.3.1,7284.0.0,7296.30.9,7305.0.0,7306.2.2,7308.0.0,7327.0.0,7334.1.1,7343.5.1,7353.0.0,7360.1.1,7362.32.1,7368.2.1,7384.0.0,7385.0.0,7395.9.3,7402.7.1,7404.0.0,7414.2.1,7436.0.0,7440.0.0,7450.0.0,7451.0.0,7484.3.3,7500.0.0,7501.0.0,7527.0.0,7550.0.0,7552.23.1,7561.84.3,7576.0.0,7603.0.0,7605.0.1,7625.0.0,7634.0.0,7635.0.0,7660.1.1,7666.0.0,7696.0.1,7700.0.0,7715.0.0,7740.11.3,7741.0.0,7763.0.0,7765.5.2,7787.0.0,7808.0.0,7821.0.0,7825.0.0,7832.3.2,7844.0.0,7858.0.0,7861.26.4,7865.0.0,7867.0.0,7870.0.0,7871.0.0,7878.2.0,7890.1.1,7895.0.0,7896.0.1,7899.0.0,7912.0.0,7913.0.0,7937.0.0,7947.0.0,7950.0.0,7983.0.0,7990.0.0,7992.12.2,8001.0.0,8017.0.0,8026.0.0,8027.3.2,8033.0.0,8037.0.0,8039.0.0,8049.0.0,8056.0.0,8072.0.0,8073.0.0,8075.2.1,8092.0.0,8103.9.0,8115.17.0,8121.2.1,8130.0.1,8141.0.1,8143.2.1,8167.0.0,8171.6.1,8193.0.0,8197.7.6,8210.3.1,8218.0.0,8220.0.0,8227.0.0,8231.4.2,8235.0.0,8248.5.3,8258.11.2,8267.0.0,8272.0.0,8275.3.1,8280.0.0,8287.5.1,8298.3.0,8306.0.0,8326.19.1,8336.10.2,8347.13.2,8348.2.1,8354.4.1,8365.4.3,8385.0.0,8390.8.2,8400.0.0,8405.8.1,8410.0.3,8425.6.1,8426.5.1,8434.0.0,8444.0.0,8448.0.0,8451.0.0,8459.0.0,8477.0.0,8483.0.0,8485.6.1,8494.0.0,8506.0.0,8524.0.0,8536.0.0,8549.5.2,8558.0.0,8591.0.1,8592.0.0,8598.0.0,8605.0.0,8617.0.0,8621.2.2,8624.4.1,8625.3.2,8627.0.0,8637.0.0,8651.2.2,8652.2.2,8656.3.1,8657.0.0,8667.0.0,8671.2.2,8674.2.1,8676.2.1,8683.3.2,8691.1.1,8692.0.0,8693.0.0,8694.12.1,8697.6.1,8698.0.0,8700.5.0,8708.0.0,8711.0.0,8714.8.1,8718.0.0,8738.2.1,8743.3.1,8763.3.1,8769.0.0,8789.15.1,8798.2.1,8817.0.1,8820.0.0,8832.0.1,8867.5.1,8885.0.0,8894.0.0,8900.0.1,8915.0.0,8919.0.0,8928.12.3,8932.0.2,8940.0.0,8941.0.0,8952.0.0,8954.0.0,8955.0.0,8956.0.0,8963.0.0,8967.0.0,8968.0.0,8976.6.2,8987.0.0,8991.4.1,8992.0.0,8996.1.1,9008.0.0,9014.0.0,9023.0.0,9026.0.0,9032.0.0,9035.12.1,9037.3.1,9043.8.1,9048.0.0,9056.0.0,9062.0.0,9068.0.0,9069.0.0,9100.3.2,9121.0.0,9128.0.0,9130.4.3,9134.0.0,9136.0.0,9141.0.0,9145.3.0,9151.0.0,9154.0.0,9155.0.0,9164.0.0,9165.0.0,9166.3.3,9167.0.0,9168.0.0,9169.0.0,9171.0.0,9173.2.1,9174.7.1,9182.0.0,9183.7.2,9197.0.0,9198.0.3,9199.0.0,9201.0.0,9203.0.0,9208.0.0,9214.2.1,9219.0.2,9220.9.3,9229.0.0,9246.0.0,9254.0.0,9255.0.0,9257.32.1,9281.0.0,9282.0.0,9293.2.1,9295.0.0,9296.3.1,9297.0.0,9301.0.0,9306.0.0,9333.8.1,9343.0.0,9347.0.0,9351.0.0,9353.0.0,9363.0.0,9364.0.0,9368.0.0,9385.0.0,9410.0.0,9418.0.0,9419.0.0,9420.3.2,9424.1.2,9427.7.1,9431.7.0,9434.3.2,9439.0.0,9441.2.2,9444.0.0,9455.1.1,9460.3.1,9461.0.0,9469.3.1,9475.1.1,9477.0.0,9483.22.0,9491.3.1,9493.0.0,9501.0.0,9508.0.0,9510.2.2,9513.0.0,9516.20.2,9524.0.0,9528.2.2,9531.3.3,9538.0.1,9549.0.0,9564.0.0,9565.0.0,9566.2.2,9567.2.2,9581.0.0,9583.0.0,9585.13.2,9586.1.1,9588.0.0,9593.0.0,9596.0.0,9601.0.0,9605.5.2,9606.13.2,9613.5.2,9619.2.2,9625.0.0,9629.0.0,9630.3.1,9635.0.0,9656.0.0,9657.0.0,9659.0.0,9660.0.0,9661.0.0,9665.5.2,9669.0.1,9679.3.1,9691.6.1,9692.8.1,9693.0.0,9697.1.1,9699.4.1,9714.0.0,9727.3.4,9728.0.0,9729.1.1,9733.16.1,9737.0.0,9748.0.0,9749.0.0,9750.0.0,9752.0.0,9754.5.2,9757.13.2,9758.4.1,9763.2.1,9771.1.1,9785.0.0,9789.0.0,9792.0.0,9806.5.2,9808.2.1,9810.0.0,9819.1.1,9837.4.4,9854.0.0,9857.0.0,9863.2.2,9864.0.0,9865.7.0,9871.0.0,9876.0.0,9884.15.5,9890.0.0,9892.0.0,9897.0.0,9914.2.2,9924.9.2,9930.0.0,9945.0.0,9948.0.0,9955.0.0,9961.0.0,9962.0.0,9968.0.0,9971.14.1,9974.0.0,9980.0.0,9991.5.2,9992.0.0,9993.0.0,10001.2.2,10002.0.0,10007.4.2,10008.2.1,10013.0.0,10014.9.1,10015.5.1,10025.0.0,10029.3.1,10032.0.0,10033.0.0,10038.1.1,10039.0.0,10040.2.1,10042.2.1,10044.0.0,10049.0.0,10055.0.0,10057.6.6,10058.3.2,10059.0.0,10060.0.0,10061.0.0,10074.0.0,10076.0.0,10077.3.1,10079.0.0,10083.0.0,10085.2.1,10086.0.0,10094.4.1,10101.3.1,10103.6.1,10108.0.0,10110.2.1,10113.0.0,10118.3.2,10121.1.1,10125.3.1,10127.2.1,10135.5.1,10137.0.0,10139.0.0,10142.2.1,10148.2.1,10155.0.0,10173.1.1,10185.0.0,10187.0.0,10192.0.1,10195.4.0,10199.2.1,10200.5.1,10203.14.1,10211.0.0,10212.3.1,10214.0.0,10218.1.3,10220.3.2,10223.4.1,10230.0.0,10231.0.0,10235.0.0,10243.0.0,10246.0.0,10247.2.1,10248.5.1,10251.0.0,10255.0.0,10257.2.1,10259.0.0,10261.3.1,10262.0.0,10264.0.0,10268.0.0,10275.2.1,10276.1.1,10278.6.1,10282.6.2,10286.2.1,10287.0.0,10291.4.2,10299.0.0,10300.3.1,10301.2.3,10306.4.3,10315.2.1,10320.0.0,10323.0.0,10324.0.0,10325.0.0,10326.0.0,10334.0.0,10335.1.1,10336.0.0,10343.0.2,10344.0.2,10345.0.1,10346.0.0,10355.0.0,10361.5.2,10390.3.2,10396.2.1,10397.4.1,10402.1.1,10416.1.1,10423.0.0,10424.2.0,10440.2.3,10443.3.2,10472.0.0,10473.0.0,10482.3.2,10483.0.0,10500.5.1,10517.0.0,10520.0.0,10555.1.1,10565.5.1,10566.4.3,10567.2.1,10569.5.2,10571.6.5"
            }
          }
        },
        "trackingTags": [],
        "adBanner": {
          "adsLoaderUrl": "https://www.uciservice.com/assets/meso-loaders/ads-loader.js",
          "slotConfigurations": [],
          "targetingConfiguration": {
            "mc1": "60983dcf9fe84006b2890431ce01eb92",
            "cmptst": "",
            "d": null,
            "activity": "f7f3273b-ccba-49d1-8219-dee673fb3194",
            "ssl": true
          },
          "variant": null,
          "pageId": null,
          "es5LibraryUrl": "https://www.uciservice.com/assets/meso-loaders/ads-loader.es5.js",
          "libraryUrl": "https://www.uciservice.com/assets/ads/2.0/fb882cc746c927150fee0cc3df4f5e1943f9abe6/expads-hcom-min.js"
        },
        "tracking": {
          "harvesterUrl": "https://apihotels.net/onestream/events/",
          "omniture": {
            "s.channel": "go guides :: long form",
            "s.currencyCode": "THB",
            "s.eVar4": "|SI:auth|VS:newVisitor|HCR:member|FC:connected|NS:notSubscribed|TI:gold|SM:HoB|IR:authAccountHolder|",
            "s.eVar6": "1714339",
            "s.eVar13": "251426",
            "s.eVar26": "SG::SINGAPORE:",
            "s.eVar33": "go guides :: long form :: things to do :: thailand|wat-arun",
            "s.eVar34": "M4869:001.000,M6184:000.000,M7296:030.009,M7561:084.003,M7576:000.000,M8287:005.001,M8448:000.000,M9246:000.000,M9491:003.001,M9991:005.002,M10059:000.000,M10325:000.000",
            "s.eVar41": "THB",
            "s.eVar43": "en_GB|HCOM_UK|uk.hotels.com",
            "s.eVar59": "Desktop|go guides :: long form :: things to do :: thailand|wat-arun",
            "s.eVar61": "Desktop",
            "s.eVar80": "",
            "s.eVar93": "chx",
            "s.events": "event295",
            "s.pageName": "go guides :: long form :: things to do :: thailand|wat-arun",
            "s.prop5": "251426",
            "s.prop18": "1714339",
            "s.prop27": "60983dcf-9fe8-4006-b289-0431ce01eb92",
            "s.prop28": "0",
            "s.prop32": "D=v43",
            "s.prop33": "D=v33",
            "s.prop34": "DestinationDiscoveryApp-",
            "s.prop36": "|SI:auth|VS:newVisitor|HCR:member|FC:connected|NS:notSubscribed|TI:gold|SM:HoB|IR:authAccountHolder|",
            "s.prop37": "1a75d41b-a2e1-44dc-911b-166a903e300d",
            "s.prop38": "ToFree:10|FreeAvail:1|AccBal:10|FreeUSD:129.1800|FreeLock:4404.0800|Curr:THB",
            "s.prop39": "TotalEarned:60|TotalRedeemed:50",
            "s.prop46": "D=v61",
            "s.server": "uk.hotels.com",
            "s.eVar95": "User Consented"
          },
          "omniture_escaped": "<script type=\\\"text/javascript\\\"><!--//--><![CDATA[//><!--\\ns.channel = \\\"go\\x5Cx20guides\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20long\\x5Cx20form\\\";s.currencyCode = \\\"THB\\\";s.eVar4 = \\\"\\x5Cx7CSI\\x5Cx3Aauth\\x5Cx7CVS\\x5Cx3AnewVisitor\\x5Cx7CHCR\\x5Cx3Amember\\x5Cx7CFC\\x5Cx3Aconnected\\x5Cx7CNS\\x5Cx3AnotSubscribed\\x5Cx7CTI\\x5Cx3Agold\\x5Cx7CSM\\x5Cx3AHoB\\x5Cx7CIR\\x5Cx3AauthAccountHolder\\x5Cx7C\\\";s.eVar6 = \\\"1714339\\\";s.eVar13 = \\\"251426\\\";s.eVar26 = \\\"SG\\x5Cx3A\\x5Cx3ASINGAPORE\\x5Cx3A\\\";s.eVar33 = \\\"go\\x5Cx20guides\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20long\\x5Cx20form\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20things\\x5Cx20to\\x5Cx20do\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20thailand\\x5Cx7Cwat\\x5Cx2Darun\\\";s.eVar34 = \\\"M4869\\x5Cx3A001.000,M6184\\x5Cx3A000.000,M7296\\x5Cx3A030.009,M7561\\x5Cx3A084.003,M7576\\x5Cx3A000.000,M8287\\x5Cx3A005.001,M8448\\x5Cx3A000.000,M9246\\x5Cx3A000.000,M9491\\x5Cx3A003.001,M9991\\x5Cx3A005.002,M10059\\x5Cx3A000.000,M10325\\x5Cx3A000.000\\\";s.eVar41 = \\\"THB\\\";s.eVar43 = \\\"en_GB\\x5Cx7CHCOM_UK\\x5Cx7Cuk.hotels.com\\\";s.eVar61 = \\\"Desktop\\\";s.eVar80 = \\\"\\\";s.eVar93 = \\\"chx\\\";s.events = \\\"event295\\\";s.pageName = \\\"go\\x5Cx20guides\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20long\\x5Cx20form\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20things\\x5Cx20to\\x5Cx20do\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20thailand\\x5Cx7Cwat\\x5Cx2Darun\\\";s.prop5 = \\\"251426\\\";s.prop18 = \\\"1714339\\\";s.prop27 = \\\"60983dcf\\x5Cx2D9fe8\\x5Cx2D4006\\x5Cx2Db289\\x5Cx2D0431ce01eb92\\\";s.prop28 = \\\"0\\\";s.prop32 = \\\"D\\x5Cx3Dv43\\\";s.prop33 = \\\"D\\x5Cx3Dv33\\\";s.prop34 = \\\"DestinationDiscoveryApp\\x5Cx2D\\\";s.prop36 = \\\"\\x5Cx7CSI\\x5Cx3Aauth\\x5Cx7CVS\\x5Cx3AnewVisitor\\x5Cx7CHCR\\x5Cx3Amember\\x5Cx7CFC\\x5Cx3Aconnected\\x5Cx7CNS\\x5Cx3AnotSubscribed\\x5Cx7CTI\\x5Cx3Agold\\x5Cx7CSM\\x5Cx3AHoB\\x5Cx7CIR\\x5Cx3AauthAccountHolder\\x5Cx7C\\\";s.prop37 = \\\"1a75d41b\\x5Cx2Da2e1\\x5Cx2D44dc\\x5Cx2D911b\\x5Cx2D166a903e300d\\\";s.prop38 = \\\"ToFree\\x5Cx3A10\\x5Cx7CFreeAvail\\x5Cx3A1\\x5Cx7CAccBal\\x5Cx3A10\\x5Cx7CFreeUSD\\x5Cx3A129.1800\\x5Cx7CFreeLock\\x5Cx3A4404.0800\\x5Cx7CCurr\\x5Cx3ATHB\\\";s.prop39 = \\\"TotalEarned\\x5Cx3A60\\x5Cx7CTotalRedeemed\\x5Cx3A50\\\";s.prop46 = \\\"D\\x5Cx3Dv61\\\";s.server = \\\"uk.hotels.com\\\";s.eVar95 = \\\"User\\x5Cx20Consented\\\"; if (dio.getObjectByName('dio.util.tracking')) { s.eVar59=dio.util.tracking.responsive('Desktop|go guides :: long form :: things to do :: thailand|wat-arun'); } ; s.list3 = 'D=v34'; s.t();s.eVar34 = null;\\n  //--><!]]><\\/script>",
          "universal_analytics": {
            "account": "UA-32616238-1",
            "_anonymizeIp": "false",
            "allowLinker": true,
            "enabled": "true",
            "page_view": {
              "PAGE_NAME": "ga(\"set\", \"page\", \"go\\x20guides\\x20\\x3A\\x3A\\x20long\\x20form\\x20\\x3A\\x3A\\x20things\\x20to\\x20do\\x20\\x3A\\x3A\\x20thailand\\x7Cwat\\x2Darun\");",
              "USER_ID": "ga(\"set\", \"userId\", \"60b5313ad0ac64f58ab1ea3565a287eb89b38af248ab6d7db59efd8029709ff1\");",
              "CID": "ga(\"set\", \"dimension1\", \"251426\");",
              "USER_CONTEXT": "ga(\"set\", \"dimension2\", \"en_GB\\x7CHCOM_UK\\x7Cuk.hotels.com\");",
              "GUID": "ga(\"set\", \"dimension3\", \"60983dcf\\x2D9fe8\\x2D4006\\x2Db289\\x2D0431ce01eb92\");",
              "PROFILE_ID": "ga(\"set\", \"dimension4\", \"1a75d41b\\x2Da2e1\\x2D44dc\\x2D911b\\x2D166a903e300d\");",
              "LOG_IN_STATUS": "ga(\"set\", \"dimension5\", \"Signed\\x20In\");",
              "WELCOME_REWARDS_STATUS": "ga(\"set\", \"dimension6\", \"WR\\x20Member\");",
              "MOBILE_PLATFORM": "ga(\"set\", \"dimension7\", \"DESKTOP\");",
              "RESOLVED_DESTINATION": "ga(\"set\", \"dimension10\", \"neighborhood\\x7CBangkok\\x2DRiverside\\x7Cbangkok\\x7Cthailand\\x7C1714339\");",
              "RESTRICTED_LAST_TOUCH_MARKETING_CODE": "ga(\"set\", \"dimension14\", \"seo.hcom.gb.z.www.google.com\");",
              "LAST_TOUCH_MARKETING_CODE": "ga(\"set\", \"dimension15\", \"seo.hcom.gb.z.www.google.com\");",
              "SHA_256_EMAIL_ADDRESS": "ga(\"set\", \"dimension65\", \"60b5313ad0ac64f58ab1ea3565a287eb89b38af248ab6d7db59efd8029709ff1\");",
              "FULL_URL": "ga(\"set\", \"dimension80\", \"https\\x3A\\x2F\\x2Fuk.hotels.com\\x2Fgo\\x2Fthailand\\x2Fwat\\x2Darun\\x3Fformat\\x3Djson\");"
            },
            "googleTagManagerId": "",
            "profileId": "1a75d41b-a2e1-44dc-911b-166a903e300d"
          },
          "ensighten": {
            "url": "//nexus.ensighten.com/hotelscom/prod/Bootstrap.js"
          },
          "tag_commander": {
            "container": "//cdn.tagcommander.com/4285/tc_hotels_com_20.js",
            "serverside_pixel": "https://serverside4285.tagcommander.com/21/"
          },
          "unified_data_toolkit": {
            "content": null
          }
        },
        "configuration": {
          "OMNITURE_S_ACCOUNT": "hotelsallprod",
          "OMNITURE_S_LNK_INT_FLTR": "javascript:,hotels.com,hoteis.com,hoteles.com,hotels.cn",
          "OMNITURE_S_SURVEY_ACCOUNT": "hotelsallprod"
        },
        "pointOfSale": {
          "numberSeparators": ",.",
          "brandName": "Hotels.com"
        },
        "user": {
          "firstName": "Wittaya",
          "lastName": "Saekoew"
        }
      },
      "body": {
        "@type": "longform",
        "h1": "Wat Arun in Bangkok",
        "h2": "Temple of Dawn",
        "introText": "<p>Wat Arun, locally known as Wat Chaeng, is a landmark temple on the west (Thonburi) bank of the Chao Phraya river. It’s easily one of the most stunning temples in Bangkok, not only because of its riverside location but also because the design is very different from the other temples you can visit in the Thai capital. Wat Arun (nicknamed the 'Temple of Dawn') is partly made up of colourfully decorated spires and stands majestically over the water.</p>\n<p>Wat Arun is almost directly opposite Wat Pho, so it’s very easy to get to. From Saphan Taksin boat pier you can take a riverboat that stops at Pier 8. From here, a small shuttle boat takes you from one side of the river to the other.</p><p>Wat Arun in Bangkok - one of the highlights of <a href='/go/thailand/best-bangkok-things-to-do'>28 Best Things to Do in Bangkok</a> and <a href='/go/thailand/bangkok-short-things-to-do'>9 Short Things to Do in Bangkok</a> (Read all about <a href='/go/thailand/bangkok'>Bangkok</a> here)</p>",
        "content": [{
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production50/d1634/bbe337ad-02fe-49d6-b761-02cab15d54f9.jpg"
          }
        }, {
          "html": {
            "paragraph": "\n<h3>Visiting Wat Arun</h3>\n<p>We would recommend spending at least an hour visiting the temple. Although it’s known as the Temple of the Dawn, it's absolutely stunning at sunset, particularly when lit up at night. Even so, the quietest time to visit is early morning, before the crowds.</p>\n<p>Given the beauty of the architecture and the fine craftsmanship, it’s not surprising that Wat Arun is considered by many as one of the most beautiful temples in Thailand. The <em>prang</em> (spire) by the Chao Phraya is one of Bangkok's world-famous landmarks. The imposing spire rises over 70 metres high, beautifully decorated with tiny pieces of coloured glass and Chinese porcelain placed delicately into intricate patterns.</p>\n"
          }
        }, {
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production81/d905/e2978a61-4404-4a3e-915c-8494584b215d.jpg",
            "attribution": {
              "photographerName": "Jonny_Joka",
              "linkToOriginal": "https://pixabay.com/photos/bangkok-wat-arun-thailand-temple-2251490/",
              "attributionVersion": "CC0",
              "linkToAttributionPage": "https://creativecommons.org/share-your-work/public-domain/cc0/"
            }
          }
        }, {
          "html": {
            "paragraph": "\n<p>You can climb the central prang if you wish – the steps are very steep but there’s a railing to help with your balance. Getting up is as tricky as getting down! When you reach the highest point you can see the winding Chao Phraya River and the Grand Palace and Wat Pho opposite. Along the base of this central tower are sculptures of Chinese soldiers and animals.</p>\n<p>Head into the ordination hall and you can admire a golden Buddha image and the detailed murals that decorate the walls. Although Wat Arun is very popular for tourists, it’s also an important place of worship for Buddhists. Make sure you dress appropriately or pick up one of the cover-ups that are available for rent near the entrance.</p>\n"
          }
        }, {
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production169/d199/a69d30f5-08d7-4ca7-82ec-52ba4a2fd5cf.jpg",
            "attribution": {
              "photographerName": "SatyaPrem",
              "linkToOriginal": "https://pixabay.com/photos/wat-arun-bangkok-thailand-3329446/",
              "attributionVersion": "CC0",
              "linkToAttributionPage": "https://creativecommons.org/share-your-work/public-domain/cc0/"
            }
          }
        }, {
          "html": {
            "paragraph": "\n<h3>History of Wat Arun</h3>\n<p>Wat Arun was envisioned by King Taksin in 1768. It’s believed that after fighting his way out of Ayutthaya, which was taken over by a Burmese army at the time, he arrived at this temple just as dawn was breaking. He later had the temple renovated and renamed it Wat Chaeng, the Temple of the Dawn. It used to be the home of the Emerald Buddha before the capital and Palace was moved to the other side of the river. This can now be seen at the Grand Palace.</p>\n<p>The central prang was extended during the reign of Rama III (between 1824 and 1851) and is now one of the most visited sites in Thailand. It was also Rama III who added the decoration of the spires with porcelain so that they glimmer in the sunshine.</p>\n"
          }
        }, {
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production19/d986/d6a5f7e6-db7c-495e-bc19-599f37c8e72f.jpg"
          }
        }],
        "info": {
          "location": "158 Wang Doem Road, Wat Arun, Bangkok Yai, Bangkok 10600, Thailand",
          "phoneNumber": "+66 (0)2 891 2185",
          "openingHours": "Daily from 8am to 5.30pm",
          "geo": {
            "coord": {
              "lat": "13.743611111111",
              "lon": "100.48888888888"
            }
          }
        },
        "writer": {
          "name": "Willy Thuan",
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production152/d1156/b4fcb800-af47-11e8-9634-0242ac110002.jpg",
          "descriptorKey": "compulsive_traveller"
        },
        "image": {
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production189/d768/a05e9e67-8808-47c0-84ab-3a0b086d48b8.jpg"
        },
        "locale": "en_GB",
        "parentPageId": "4f35c9f1-6d82-541c-8166-dd5a3bb8e7f0",
        "destinationId": "1714339",
        "gaiaId": "6160156",
        "contentSource": "portal_migration",
        "listicleGroup": "things_to_do",
        "segmentCodes": ["history", "photo", "budget"],
        "categoryCodes": {
          "things_to_do": ["landmark___historical", "temple___church"]
        },
        "id": 1423483,
        "sharedId": 1423482,
        "mainCategory": "things_to_do",
        "omnitureSiteSectionCode": "things_to_do",
        "tagCodeNames": ["history", "photo", "budget"],
        "urlCorrectionEnabled": true,
        "travelBlog": false,
        "version": 2,
        "countryName": "Thailand",
        "cityName": "Bangkok",
        "destinationName": "Bangkok Riverside",
        "destinationType": "neighborhood",
        "categoryCode": "things_to_do",
        "breadcrumb": [{
          "name": "GO",
          "targetUrl": "/go?intlid=gglfrm|bread"
        }, {
          "name": "Thailand",
          "targetUrl": "/go/thailand?intlid=gglfrm|bread"
        }, {
          "name": "Bangkok",
          "targetUrl": "/go/thailand/bangkok?intlid=gglfrm|bread"
        }, {
          "name": "Bangkok Riverside",
          "targetUrl": "/go/thailand/bangkok-riverside?intlid=gglfrm|bread",
          "lastNodeWithTargetUrl": true
        }],
        "displayFallbackLanguageContent": false,
        "h1Length": 19,
        "relatedStories": [{
          "name": "18 Great Restaurants in Bangkok",
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production91/d1818/49ab5c8e-c0cf-48a7-bcf6-9dfa8b119f76.jpg",
          "targetUrl": "/go/thailand/best-bangkok-restaurants?intlid=gglfrm|related",
          "countryName": "Thailand",
          "isBlog": false,
          "createdDate": null,
          "city": "Thailand"
        }, {
          "name": "10 Best Bangkok Night Markets",
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production101/d1281/172ea185-4ada-4649-bec1-ea9e9c6ea187.jpg",
          "targetUrl": "/go/thailand/best-bangkok-night-markets?intlid=gglfrm|related",
          "countryName": "Thailand",
          "isBlog": false,
          "createdDate": null,
          "city": "Thailand"
        }, {
          "name": "Maggie Choo's Bar in Bangkok",
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production35/d282/adb5fe0d-fb51-40a5-a418-c9e52279e4e3.jpg",
          "targetUrl": "/go/thailand/maggie-choos-bar-bangkok?intlid=gglfrm|related",
          "countryName": "Thailand",
          "isBlog": false,
          "createdDate": null,
          "city": "Thailand"
        }, {
          "name": "IKEA Bangkok",
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production199/d553/efcb22d7-e390-4089-a998-da1d363d5a4b.jpg",
          "targetUrl": "/go/thailand/ikea-bangkok?intlid=gglfrm|related",
          "countryName": "Thailand",
          "isBlog": false,
          "createdDate": null,
          "city": "Thailand"
        }, {
          "name": "5 Thai Desserts You Should Try",
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production95/d17/c3c4e479-bea9-44ae-bf0f-ed0cbcb68023.jpg",
          "targetUrl": "/go/thailand/thai-desserts-should-try?intlid=gglfrm|related",
          "countryName": "Thailand",
          "isBlog": false,
          "createdDate": null,
          "city": "Thailand"
        }, {
          "name": "10 Unusual Things to Do in Bangkok Chinatown",
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production47/d208/f9b1a535-535b-4837-a099-c41db371f159.jpg",
          "targetUrl": "/go/thailand/unusual-chinatown-things-to-do?intlid=gglfrm|related",
          "countryName": "Thailand",
          "isBlog": false,
          "createdDate": null,
          "city": "Thailand"
        }, {
          "name": "Don Mueang Area Guide",
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production7/d408/226d5745-4d57-494a-b64d-1d600d2a5027.jpg",
          "targetUrl": "/go/thailand/don-mueang-area-guide?intlid=gglfrm|related",
          "countryName": "Thailand",
          "isBlog": false,
          "createdDate": null,
          "city": "Thailand"
        }, {
          "name": "Robinson Bangrak Shopping Mall",
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production53/d80/e1baddbc-a3a5-4bcf-a7e2-1bf7dae77b40.jpg",
          "targetUrl": "/go/thailand/robinson-bangrak?intlid=gglfrm|related",
          "countryName": "Thailand",
          "isBlog": false,
          "createdDate": null,
          "city": "Thailand"
        }],
        "destinationList": {
          "country": {
            "name": "Thailand",
            "targetUrl": "/go/thailand?intlid=gglfrm|keepexp",
            "neighbourhoods": {
              "name": "Bangkok",
              "targetUrl": "/go/thailand/bangkok?intlid=gglfrm|keepexp",
              "list": [{
                "name": "Bangkok Old Town",
                "targetUrl": "/go/thailand/bangkok-old-town?intlid=gglfrm|keepexp"
              }, {
                "name": "Bangkok Riverside",
                "targetUrl": "/go/thailand/bangkok-riverside?intlid=gglfrm|keepexp"
              }, {
                "name": "Chatuchak",
                "targetUrl": "/go/thailand/bangkok-chatuchak?intlid=gglfrm|keepexp"
              }, {
                "name": "Chinatown",
                "targetUrl": "/go/thailand/bangkok-chinatown?intlid=gglfrm|keepexp"
              }, {
                "name": "Khao San",
                "targetUrl": "/go/thailand/bangkok-khao-san?intlid=gglfrm|keepexp"
              }, {
                "name": "Ploenchit",
                "targetUrl": "/go/thailand/bangkok-ploenchit?intlid=gglfrm|keepexp"
              }, {
                "name": "Pratunam",
                "targetUrl": "/go/thailand/bangkok-pratunam?intlid=gglfrm|keepexp"
              }, {
                "name": "Ratchadaphisek",
                "targetUrl": "/go/thailand/bangkok-ratchadaphisek?intlid=gglfrm|keepexp"
              }, {
                "name": "Sathon",
                "targetUrl": "/go/thailand/bangkok-sathorn?intlid=gglfrm|keepexp"
              }, {
                "name": "Siam",
                "targetUrl": "/go/thailand/bangkok-siam?intlid=gglfrm|keepexp"
              }, {
                "name": "Silom",
                "targetUrl": "/go/thailand/bangkok-silom?intlid=gglfrm|keepexp"
              }, {
                "name": "Sukhumvit",
                "targetUrl": "/go/thailand/bangkok-sukhumvit?intlid=gglfrm|keepexp"
              }, {
                "name": "Thon Buri",
                "targetUrl": "/go/thailand/bangkok-thon-buri?intlid=gglfrm|keepexp"
              }]
            },
            "allCities": {
              "name": "Thailand",
              "targetUrl": "/go/thailand?intlid=gglfrm|keepexp",
              "list": [{
                "name": "Ayutthaya",
                "targetUrl": "/go/thailand/ayutthaya?intlid=gglfrm|keepexp"
              }, {
                "name": "Bangkok",
                "targetUrl": "/go/thailand/bangkok?intlid=gglfrm|keepexp"
              }, {
                "name": "Chiang Mai",
                "targetUrl": "/go/thailand/chiang-mai?intlid=gglfrm|keepexp"
              }, {
                "name": "Chiang Rai",
                "targetUrl": "/go/thailand/chiang-rai?intlid=gglfrm|keepexp"
              }, {
                "name": "Hua Hin",
                "targetUrl": "/go/thailand/hua-hin?intlid=gglfrm|keepexp"
              }, {
                "name": "Kanchanaburi",
                "targetUrl": "/go/thailand/kanchanaburi?intlid=gglfrm|keepexp"
              }, {
                "name": "Khao Lak",
                "targetUrl": "/go/thailand/khao-lak?intlid=gglfrm|keepexp"
              }, {
                "name": "Ko Chang",
                "targetUrl": "/go/thailand/ko-chang?intlid=gglfrm|keepexp"
              }, {
                "name": "Ko Lanta",
                "targetUrl": "/go/thailand/ko-lanta?intlid=gglfrm|keepexp"
              }, {
                "name": "Ko Pha-ngan",
                "targetUrl": "/go/thailand/koh-phangan?intlid=gglfrm|keepexp"
              }, {
                "name": "Ko Phi Phi",
                "targetUrl": "/go/thailand/phi-phi?intlid=gglfrm|keepexp"
              }, {
                "name": "Koh Samui",
                "targetUrl": "/go/thailand/koh-samui?intlid=gglfrm|keepexp"
              }, {
                "name": "Koh Tao",
                "targetUrl": "/go/thailand/koh-tao?intlid=gglfrm|keepexp"
              }, {
                "name": "Krabi",
                "targetUrl": "/go/thailand/krabi?intlid=gglfrm|keepexp"
              }, {
                "name": "Pai",
                "targetUrl": "/go/thailand/pai?intlid=gglfrm|keepexp"
              }, {
                "name": "Pattaya (and vicinity)",
                "targetUrl": "/go/thailand/pattaya?intlid=gglfrm|keepexp"
              }, {
                "name": "Phuket Province",
                "targetUrl": "/go/thailand/phuket?intlid=gglfrm|keepexp"
              }, {
                "name": "Sukhothai",
                "targetUrl": "/go/thailand/sukhothai?intlid=gglfrm|keepexp"
              }, {
                "name": "Trang",
                "targetUrl": "/go/thailand/trang?intlid=gglfrm|keepexp"
              }, {
                "name": "Udon Thani",
                "targetUrl": "/go/thailand/udon-thani?intlid=gglfrm|keepexp"
              }]
            },
            "regions": [{
              "name": "Phang Nga",
              "targetUrl": "/go/thailand/phang-nga?intlid=gglfrm|keepexp"
            }, {
              "name": "Satun",
              "targetUrl": "/go/thailand/satun?intlid=gglfrm|keepexp"
            }, {
              "name": "Surat Thani Province",
              "targetUrl": "/go/thailand/surat-thani?intlid=gglfrm|keepexp"
            }]
          },
          "continents": [{
            "name": "Asia",
            "targetUrl": "/go/asia?intlid=gglfrm|keepexp",
            "countries": [{
              "name": "Cambodia",
              "targetUrl": "/go/cambodia?intlid=gglfrm|keepexp"
            }, {
              "name": "China",
              "targetUrl": "/go/china?intlid=gglfrm|keepexp"
            }, {
              "name": "Hong Kong SAR",
              "targetUrl": "/go/hong-kong?intlid=gglfrm|keepexp"
            }, {
              "name": "Indonesia",
              "targetUrl": "/go/indonesia?intlid=gglfrm|keepexp"
            }, {
              "name": "Japan",
              "targetUrl": "/go/japan?intlid=gglfrm|keepexp"
            }, {
              "name": "Laos",
              "targetUrl": "/go/laos?intlid=gglfrm|keepexp"
            }, {
              "name": "Malaysia",
              "targetUrl": "/go/malaysia?intlid=gglfrm|keepexp"
            }, {
              "name": "Philippines",
              "targetUrl": "/go/philippines?intlid=gglfrm|keepexp"
            }, {
              "name": "Singapore",
              "targetUrl": "/go/singapore?intlid=gglfrm|keepexp"
            }, {
              "name": "South Korea",
              "targetUrl": "/go/south-korea?intlid=gglfrm|keepexp"
            }, {
              "name": "Taiwan",
              "targetUrl": "/go/taiwan?intlid=gglfrm|keepexp"
            }, {
              "name": "Thailand",
              "targetUrl": "/go/thailand?intlid=gglfrm|keepexp"
            }, {
              "name": "Vietnam",
              "targetUrl": "/go/vietnam?intlid=gglfrm|keepexp"
            }]
          }, {
            "name": "Africa",
            "targetUrl": "/go/africa?intlid=gglfrm|keepexp"
          }, {
            "name": "Australia - New Zealand and the South Pacific",
            "targetUrl": "/go/oceania?intlid=gglfrm|keepexp"
          }, {
            "name": "Caribbean",
            "targetUrl": "/go/caribbean?intlid=gglfrm|keepexp"
          }, {
            "name": "Europe",
            "targetUrl": "/go/europe?intlid=gglfrm|keepexp"
          }, {
            "name": "Mexico and Central America",
            "targetUrl": "/go/mexico-central-america?intlid=gglfrm|keepexp"
          }, {
            "name": "Middle East",
            "targetUrl": "/go/middle-east?intlid=gglfrm|keepexp"
          }, {
            "name": "North America",
            "targetUrl": "/go/north-america?intlid=gglfrm|keepexp"
          }, {
            "name": "South America",
            "targetUrl": "/go/south-america?intlid=gglfrm|keepexp"
          }]
        },
        "query": {
          "label": "Start planning your trip",
          "destination": {
            "value": "Bangkok Riverside",
            "id": "1714339"
          },
          "dates": null,
          "l10nDateFormat": {
            "defaultFormat": "dd/MM/yyyy",
            "firstDayOfWeek": 1,
            "l10nFormat": "dd/mm/yyyy",
            "l10nFormatFull": "{EEE} {d} {MMMM} {yyyy}",
            "monthNames": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "shortWeekDayNames": ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            "weekDayNames": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
          },
          "rooms": {
            "selected": [{
              "adults": 2,
              "children": []
            }]
          },
          "filter": {},
          "compactOccupancy": [{
            "adults": 1,
            "rooms": 1,
            "selected": false
          }, {
            "adults": 2,
            "rooms": 1,
            "selected": true
          }],
          "sort": {},
          "options": {
            "dateCheckboxOnPopup": false,
            "ctaLabelKey": "landing.qf.button.title.show_deals",
            "destinationLabelFirst": false,
            "displayInline": false,
            "dateCheckbox": false,
            "knownDestination": false
          },
          "savedSearch": false
        },
        "categoryLinks": [{
          "name": "Things to do",
          "targetUrl": "/go/thailand/bangkok-things-to-do?intlid=gglfrm|category"
        }],
        "menu": {
          "home": {
            "name": "Go Guides",
            "targetUrl": "/go?intlid=gglfrm|menu"
          },
          "destination": {
            "name": "Bangkok",
            "targetUrl": "/go/thailand/bangkok?intlid=gglfrm|menu"
          },
          "category": [{
            "name": "Things to do",
            "categoryKey": "things_to_do",
            "targetUrl": "/go/thailand/bangkok-things-to-do?intlid=gglfrm|menu"
          }, {
            "name": "Food",
            "categoryKey": "food",
            "targetUrl": "/go/thailand/bangkok-food?intlid=gglfrm|menu"
          }, {
            "name": "Shopping",
            "categoryKey": "shopping",
            "targetUrl": "/go/thailand/bangkok-shopping?intlid=gglfrm|menu"
          }, {
            "name": "Nightlife",
            "categoryKey": "nightlife",
            "targetUrl": "/go/thailand/bangkok-nightlife?intlid=gglfrm|menu"
          }, {
            "name": "Tours",
            "categoryKey": "tours",
            "targetUrl": "/go/thailand/bangkok-tours?intlid=gglfrm|menu"
          }, {
            "name": "Information",
            "categoryKey": "information",
            "targetUrl": "/go/thailand/bangkok-information?intlid=gglfrm|menu"
          }],
          "moreButtonText": "More"
        },
        "urlSlug": "wat-arun",
        "omniture": {
          "urlSlug": "wat-arun",
          "sitemapCountryName": "thailand",
          "siteSection": "go guides :: long form",
          "isRobot": "false",
          "pageCategory": "things to do",
          "appName": "go guides",
          "regionName": "",
          "listicleGroup": "things to do",
          "destinationId": "1714339",
          "pageName": "go guides :: long form :: things to do :: thailand|wat-arun",
          "platform": "",
          "pageLocation": "as|thailand|bangkok|bangkok-riverside",
          "pageType": "Long form",
          "cityName": "bangkok",
          "pageTypeTrackingName": "long form",
          "destinationName": "Bangkok-Riverside",
          "destinationType": "neighborhood",
          "countryName": "thailand",
          "continentCode": "as"
        }
      },
      "debug": {}
    }
  }
};